import React from 'react';
import { Link } from 'react-router-dom';

export const MenuLink = ({
  to = '',
  children,
  colorClass = 'bg-primary-darker text-white',
}) => (
  <li
    className={`flex items-center ${colorClass} text-xs font-bold px-2 py-1.5 rounded-md`}
  >
    {to ? (
      <Link to={to} className="flex items-center">
        {children}
      </Link>
    ) : (
      children
    )}
  </li>
);
